import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const limitationsBoxStyles = css`
  padding: ${theme.spacing(0)} ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(4)};
`

export const manageButtonBoxStyles = css`
  display: flex;
  justify-content: flex-end;
`

export const limitationsContentStyles = css`
  color: ${theme.palette.text.primary};
`

export const containerStyles = css`
  padding-top: ${theme.spacing(2)};
  padding-bottom: ${theme.spacing(2)};
`

export const descriptionBoxStyles = css`
  margin-bottom: ${theme.spacing(3)};
  margin-top: ${theme.spacing(3)};
`

export const paperStyles = css`
  margin-bottom: ${theme.spacing(3)};
`

export const labelCellStyles = css`
  width: 180px;
  color: ${theme.palette.text.secondary};
  border: none;
  border-bottom: 1px solid ${theme.palette.neutral.light};
  padding: ${theme.spacing(2)};
  vertical-align: top;
`

export const valueCellStyles = css`
  border: none;
  border-bottom: 1px solid ${theme.palette.neutral.light};
  padding: ${theme.spacing(2)};
  vertical-align: top;
`

export const flexRowStyles = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`

export const dotStyles = (color: string) => css`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${color};
  flex-shrink: 0;
`

export const emTextStyles = css`
  color: ${theme.palette.text.secondary};
`

export const sourcesListStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(0.5)};
`

export const sourceLinkStyles = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
`

export const iconSmallStyles = css`
  font-size: 12px;
`
